import React, { useEffect, useState } from "react";
import { Chart } from "react-google-charts";
import getByCountries from "./apis/getByContries";

const options = {
  title: "Users by Country",
  pieHole: 0.4,
  is3D: false,
  colorAxis: {
    minValue: 0,
    colors: ["#D17AF3", "#b421ec", "#490863", "#0E0113"],
  },
};

const CountryChart = ({ botId, userId }) => {
  const [data, setData] = useState([["Country", "Users"]]); // Chart header
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCountryData = async () => {
      setLoading(true);
      const res = await getByCountries(botId, userId);

      if (res.error) {
        setData([["Country", "Users"]]); // fallback to only headers
        setLoading(false);
        return;
      }

      const rawData = res?.data || [];

      const chartData = [["Country", "Users"]];
      rawData.forEach((ele) => {
        const countryName =
          ele.country && ele.country.trim() !== "" ? ele.country : "Unknown";
        chartData.push([countryName, ele.count || 0]);
      });

      setData(chartData);
      setLoading(false);
    };

    if (botId && userId) {
      fetchCountryData();
    }
  }, [botId, userId]);

  return (
    <div className="w-full">
      {loading ? (
        <p className="text-gray-500 text-center">Loading chart...</p>
      ) : (
        <Chart
          chartType="GeoChart"
          width="100%"
          height="400px"
          data={data}
          options={options}
        />
      )}
    </div>
  );
};

export default CountryChart;
